/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import {
    pluginRestServerStrategyConfig,
    pluginRestServerStrategyFlow,
    tokenManagerTransportStrategyConfig,
    tokenManagerTransportStrategyFlow,
    pluginWebServerStrategyConfig,
    pluginWebServerStrategyFlow,
    pluginWebServerDownloadStrategyConfig,
    pluginWebServerDownloadStrategyFlow,
    mainStreamUploadStrategyFlow,
    mainStreamUploadStrategyConfig,
    mainRestServerStrategyFlow,
    mainRestServerStrategyConfig,
    mainWebServerStrategyFlow,
    mainWebServerStrategyConfig,
    mainWebServerDownloadStrategyFlow,
    mainWebServerDownloadStrategyConfig,
    mainStreamUploadRestStrategyConfig,
    mainStreamUploadRestStrategyFlow,
} from './strategies';

export const tokenManagerTransportStrategy = {
    flow: tokenManagerTransportStrategyFlow,
    config: tokenManagerTransportStrategyConfig,
};

export const mainRestServerTransportStrategy = {
    flow: mainRestServerStrategyFlow,
    config: mainRestServerStrategyConfig,
};

export const mainWebServerTransportStrategy = {
    flow: mainWebServerStrategyFlow,
    config: mainWebServerStrategyConfig,
};

export const mainFileTransportStrategy = {
    flow: mainWebServerDownloadStrategyFlow,
    config: mainWebServerDownloadStrategyConfig,
};

export const mainStreamUploadFileTransportStrategy = {
    flow: mainStreamUploadStrategyFlow,
    config: mainStreamUploadStrategyConfig,
};

export const mainStreamUploadFileRestTransportStrategy = {
    flow: mainStreamUploadRestStrategyFlow,
    config: mainStreamUploadRestStrategyConfig,
};

export const pluginRestServerTransportStrategy = {
    flow: pluginRestServerStrategyFlow,
    config: pluginRestServerStrategyConfig,
};

export const pluginWebServerTransportStrategy = {
    flow: pluginWebServerStrategyFlow,
    config: pluginWebServerStrategyConfig,
};

export const pluginFileTransportStrategy = {
    flow: pluginWebServerDownloadStrategyFlow,
    config: pluginWebServerDownloadStrategyConfig,
};
